// src/lib/token.js

const API_BASE = process.env.REACT_APP_API_URL || "";

export async function ensureToken() {
  let token = localStorage.getItem("fq_token");

  if (!token) {
    const res = await fetch(`${API_BASE}/api/auth/guest`, {
      method: "POST",
    });

    if (!res.ok) throw new Error("guest auth failed");

    const json = await res.json();

    token = json.token;

    localStorage.setItem("fq_token", token);
  }

  return token;
}